import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../../supabase/supabase';

const { FiUsers, FiDollarSign, FiUnlock, FiHeadphones, FiTrendingUp, FiStar } = FiIcons;

const MetricCard = ({ icon: Icon, label, value, trend, color }) => (
  <div className="glass-card rounded-2xl p-5 space-y-3">
    <div className="flex items-center justify-between">
      <div className={`w-10 h-10 rounded-xl bg-zinc-900 flex items-center justify-center`}>
        <SafeIcon icon={Icon} className={`text-lg ${color}`} />
      </div>
      {trend && (
        <span className={`text-[10px] font-black uppercase tracking-widest ${trend > 0 ? 'text-green-400' : 'text-red-400'}`}>
          {trend > 0 ? '+' : ''}{trend}%
        </span>
      )}
    </div>
    <div>
      <p className="text-2xl font-black text-white">{value}</p>
      <p className="text-[10px] font-black uppercase tracking-widest text-zinc-500 mt-0.5">{label}</p>
    </div>
  </div>
);

const RealtimeMetrics = ({ artistId }) => {
  const [metrics, setMetrics] = useState({
    current_listeners: 0,
    active_subscribers: 0,
    unlocks_last_hour: 0,
    unlocks_last_24h: 0,
    revenue_today: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetchMetrics = async () => {
    if (!artistId) return;

    const { data, error } = await supabase.rpc('get_realtime_artist_metrics', {
      p_artist_id: artistId,
    });

    if (!error && data && data.length > 0) {
      setMetrics(data[0]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMetrics();

    // Poll every 30 seconds for real-time updates
    const interval = setInterval(fetchMetrics, 30000);
    return () => clearInterval(interval);
  }, [artistId]);

  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="glass-card rounded-2xl p-5 h-32 animate-pulse bg-white/5" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      <MetricCard
        icon={FiHeadphones}
        label="Current Listeners"
        value={metrics.current_listeners}
        color="text-brand-pink"
      />
      <MetricCard
        icon={FiStar}
        label="Active Subs"
        value={metrics.active_subscribers}
        trend={12}
        color="text-purple-400"
      />
      <MetricCard
        icon={FiUnlock}
        label="Unlocks (1h)"
        value={metrics.unlocks_last_hour}
        trend={8}
        color="text-brand-coral"
      />
      <MetricCard
        icon={FiTrendingUp}
        label="Unlocks (24h)"
        value={metrics.unlocks_last_24h}
        trend={15}
        color="text-blue-400"
      />
      <MetricCard
        icon={FiDollarSign}
        label="Revenue Today"
        value={`$${metrics.revenue_today?.toFixed(2) || '0.00'}`}
        trend={22}
        color="text-green-400"
      />
    </div>
  );
};

export default RealtimeMetrics;